import React, { useContext } from 'react'
import styled from 'styled-components'
import { UploadFieldBlock } from '../../blocks'
import TrimmerComponent from '../../trimmer'
import { Subtitle } from '../../typography'
import { CreationSourceEditorContext } from '../manager'

const Trimmer = styled(UploadFieldBlock)`
    grid-column: span 8;
`

const CreationSourceEditorEditPanel = () => {
    const { source, timeline, setTimeline, previewPlayheadTime } = useContext(CreationSourceEditorContext)

    return (
        <>
            <Trimmer>
                <Subtitle>Timeline</Subtitle>
                <TrimmerComponent
                    {...{
                        source,
                        playheadTime: previewPlayheadTime,
                        defaultStartTime: timeline.start,
                        defaultEndTime: timeline.end,
                        showInputs: true,
                        onUpdate: (start, end) => setTimeline({ start, end }),
                    }}
                />
            </Trimmer>
        </>
    )
}

export default CreationSourceEditorEditPanel
